var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{on:{"click":_vm.addItem}},[_vm._v("Add")]),_c('v-btn',{on:{"click":_vm.removeItem}},[_vm._v("Remove")]),_c('div',{ref:"grid",staticClass:"grid"},[_c('div',{staticClass:"grid-sizer"}),_vm._l((_vm.items),function(item){return _c('div',{staticClass:"grid-item",class:item.class,attrs:{"data-item-id":item.id}})})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }